

















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Range, Leveler } from './components';
import { fullArray } from '@/tools/fullarray';
@Component({
  components: {
    Range,
    Leveler,
  }
})
export default class ComponentsFormSliderInput extends Vue {
  @Prop({type: String, default: ''})
  question: string;

  @Prop({type: String, default: 'scale10'})
  type: string;

  @Prop({type: Boolean, default: true})
  showScale: boolean;

  @Prop({type: Boolean, default: true})
  showLeveler: boolean;

  @Prop({type: Number, required: true})
  value: number;

  @Prop({type: Boolean, default: false})
  error: boolean;

  scale: any = null;
  levelPosition: number = this.value;

  @Watch('type', { immediate: true })
  onTypeChange(value: string) {
    this.typeOfScale(value);
  }

  @Watch('levelPosition')
  onlevelChange(value: string) {
    this.$emit('input', value);
  }

  typeOfScale(value: string) {
    if (!!value) {
      switch (value) {
        case 'scale10':
          this.scale = fullArray(10);
          break;
        case 'scale5':
          this.scale = fullArray(5);
          break;
        default:
          this.scale = fullArray(10);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/formrange/FormRange.vue